import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from '@shared/i18n'
import locales from '../i18n/locales.json'

import App from '@pages/properties/App.vue'

const i18n = createI18n(locales)

document.addEventListener('DOMContentLoaded', () => {
  const pinia = createPinia()
  createApp(App).use(i18n).use(pinia).mount('main')
})
